import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { Box, ButtonBase, Typography } from '@mui/material';
var LOGIN_STRINGS = appStrings.modules.login;
var TABS = [
    { method: 'email', label: LOGIN_STRINGS.emailTab, id: 'login-method-email-tab' },
    { method: 'phone', label: LOGIN_STRINGS.phoneTab, id: 'login-method-phone-tab' },
];
export var LoginMethodTabs = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    var activeIndex = Math.max(0, TABS.findIndex(function (tab) { return tab.method === value; }));
    return (_jsxs(Box, { role: "tablist", sx: tablistSx, children: [_jsx(Box, { "aria-hidden": true, sx: thumbSx(activeIndex) }), TABS.map(function (_a) {
                var method = _a.method, label = _a.label, id = _a.id;
                var isActive = value === method;
                return (_jsx(ButtonBase, { id: id, "data-ph-capture-attribute-name": id, role: "tab", "aria-selected": isActive, onClick: function () { return onChange(method); }, disableRipple: true, sx: tabSx, children: _jsx(Typography, { variant: "text-sm-semibold", sx: { transition: 'color 0.2s ease' }, color: function (theme) {
                            return theme.backrs.colors[isActive ? 'Colors/Text/text-secondary' : 'Colors/Text/text-quaternary'];
                        }, children: label }) }, method));
            })] }));
};
var tablistSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        position: 'relative',
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        gap: backrs.spacing['spacing-xxs'],
        backgroundColor: backrs.colors['Colors/Background/bg-secondary-alt'],
        border: "1px solid ".concat(backrs.colors['Colors/Border/border-secondary']),
        borderRadius: backrs.radius['radius-md'],
    });
};
var thumbSx = function (activeIndex) {
    return function (_a) {
        var backrs = _a.backrs;
        var gap = backrs.spacing['spacing-xxs'];
        return {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            width: "calc(50% - ".concat(gap, " / 2)"),
            borderRadius: backrs.radius['radius-md'],
            backgroundColor: backrs.colors['Colors/Base/White'],
            border: "1px solid ".concat(backrs.colors['Colors/Border/border-primary']),
            boxShadow: backrs.shadows['shadow-xs'],
            transform: activeIndex === 0 ? 'none' : "translateX(calc(100% + ".concat(gap, "))"),
            transition: 'transform 0.2s ease',
            '@media (prefers-reduced-motion: reduce)': {
                transition: 'none',
            },
        };
    };
};
var tabSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        position: 'relative',
        zIndex: 1,
        flex: '1 0 0',
        minWidth: 0,
        height: '36px',
        px: backrs.spacing['spacing-lg'],
        py: backrs.spacing['spacing-md'],
        borderRadius: backrs.radius['radius-md'],
    });
};
